//#region IMPORT
import React, { useEffect, useState, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
/** Services Import */
import { useDispatch, useSelector } from 'react-redux';
import { setCoCd } from '../../../../Reducer/SearchReducer';
/** Components */
import { NOT_BASIC } from './index';
import { Loading } from '../../../../Components/MUIs';
import useCompanyCustDep from '../../../../hooks/useCompanyCustDep';
//#endregion

function NOT_BASICF() {
  //#region 변수
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { state } = useLocation();
  const [loading] = useState(false);
  const { userInfo } = useSelector((state) => state.BaseInfo);
  const searchInfo = useSelector((state) => state.SearchInfo);

  const [value, setValue] = React.useState(0);

  const { handleCoChange, validateSelection } = useCompanyCustDep({
    requireCompany: true,
    requireCust: false,
  });

  const [filterClick1, setFilterClick1] = useState(false); // 1번탭 버튼 이벤트
  const [searchClick1, setSearchClick1] = useState(false);
  const [addClick1, setAddClick1] = useState(false);
  const [saveClick1, setSaveClick1] = useState(false);
  const [deleteClick1, setDeleteClick1] = useState(false);
  const [printClick1, setPrintClick1] = useState(false);
  const [copyClick1, setCopyClick1] = useState(false);
  const [listClick1, setListClick1] = useState(false);

  const [filterClick2, setFilterClick2] = useState(false); // 2번탭 버튼 이벤트
  const [searchClick2, setSearchClick2] = useState(false);
  const [addClick2, setAddClick2] = useState(false);
  const [saveClick2, setSaveClick2] = useState(false);
  const [deleteClick2, setDeleteClick2] = useState(false);
  const [printClick2, setPrintClick2] = useState(false);
  const [listClick2, setListClick2] = useState(false);
  //#endregion

  const Init = useCallback(async () => {
    const coCdValue = state?.coCd ? state.coCd : searchInfo.coCd;

    if (coCdValue && coCdValue !== searchInfo.coCd) {
      dispatch(setCoCd(coCdValue));
    }

    setSearchClick1(true);
  }, [state, searchInfo.coCd, dispatch]);

  useEffect(() => {
    Init();
  }, [Init]); // state.coCd가 바뀔 때마다 Init 실행

  // 탭 클릭 이벤트
  const HandleChange = (event, newValue) => {
    if (newValue === 0) setSearchClick1(true);
    else if (newValue === 1) setSearchClick2(true);
    setValue(newValue);
  };
  //#endregion

  return (
    <div className="wrap">
      <NOT_BASIC
        navigate={navigate}
        userInfo={userInfo}
        value={value}
        setValue={setValue}
        filterClick1={filterClick1}
        setFilterClick1={setFilterClick1}
        searchClick1={searchClick1}
        setSearchClick1={setSearchClick1}
        addClick1={addClick1}
        setAddClick1={setAddClick1}
        saveClick1={saveClick1}
        setSaveClick1={setSaveClick1}
        deleteClick1={deleteClick1}
        setDeleteClick1={setDeleteClick1}
        printClick1={printClick1}
        setPrintClick1={setPrintClick1}
        listClick1={listClick1}
        setListClick1={setListClick1}
        filterClick2={filterClick2}
        setFilterClick2={setFilterClick2}
        searchClick2={searchClick2}
        setSearchClick2={setSearchClick2}
        addClick2={addClick2}
        setAddClick2={setAddClick2}
        saveClick2={saveClick2}
        setSaveClick2={setSaveClick2}
        deleteClick2={deleteClick2}
        setDeleteClick2={setDeleteClick2}
        printClick2={printClick2}
        setPrintClick2={setPrintClick2}
        listClick2={listClick2}
        setListClick2={setListClick2}
        copyClick1={copyClick1}
        setCopyClick1={setCopyClick1}
        // 함수
        HandleChange={HandleChange}
        handleCoChange={handleCoChange}
        validateSelection={validateSelection}
      />
      <Loading open={loading} />
    </div>
  );
}

export default NOT_BASICF;
